import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import ReviewForm from "./ReviewForm";
import Footer from "./Footer";
const Review = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <ReviewForm />
      <Footer />
    </>
  );
};

export default Review;
